import React, { useEffect, useState } from 'react'

import { updateUserStore } from 'Store/user'
import { updateClubs } from 'Store/clubs'

import Container from 'Components/shared/Container'

import Content from 'Components/shared/Content'

import ClientForm from 'Components/ClientForm'
import ClientSelect from 'Components/ClientSelect'
import AppInformation from 'Components/AppInformation'
import WelcomeMessage from 'Components/WelcomeMessage'
import HomepageLinks from 'Components/HomepageLinks'
import MenuScreen from 'Components/MenuScreen'
import Resources from 'Components/Resources'
import CustomLinks from 'Components/CustomLinks'
import SaveButtons from 'Components/SaveButtons'

import onSubmit from 'helpers/submit'

export default () => {
  const [selected, setSelected] = useState(false)
  const [club, setClub] = useState({})
  const [selectedClub, setSelectedClub] = useState({})
  const [previewImages, setPreviewImages] = useState()
  // eslint-disable-next-line no-unused-vars
  const [customLinks, setCustomLinks] = useState([])

  useEffect(async () => {
    await updateUserStore()
    await updateClubs()
  }, [])

  return (
    <>
      <Content>
        <ClientForm
          onSubmit={e => {
            onSubmit(e, selectedClub, previewImages, setPreviewImages, setSelectedClub, setClub)
          }}
        >
          <Container>
            <ClientSelect
              setSelected={setSelected}
              setSelectedClub={setSelectedClub}
              setPreviewImages={setPreviewImages}
              setMaster={setClub}
              setCustomLinks={setCustomLinks}
              club={selectedClub}
            />

            {selected && (
              <>
                <SaveButtons
                  cloned={selectedClub?.cloned}
                  setSelected={setSelected}
                  setSelectedClub={setSelectedClub}
                  setPreviewImages={setPreviewImages}
                  setMaster={setClub}
                  setCustomLinks={setCustomLinks}
                />
                <AppInformation
                  masterClub={club}
                  club={selectedClub}
                  setSelectedClub={setSelectedClub}
                  previewImages={previewImages}
                  setPreviewImages={setPreviewImages}
                />
                <WelcomeMessage
                  masterClub={club}
                  club={selectedClub}
                  setSelectedClub={setSelectedClub}
                />
                <HomepageLinks
                  masterClub={club}
                  club={selectedClub}
                  setSelectedClub={setSelectedClub}
                />
                <MenuScreen
                  masterClub={club}
                  club={selectedClub}
                  setSelectedClub={setSelectedClub}
                  previewImages={previewImages}
                />
                <Resources
                  masterClub={club}
                  club={selectedClub}
                  setSelectedClub={setSelectedClub}
                  previewImages={previewImages}
                  setPreviewImages={setPreviewImages}
                />
                <CustomLinks
                  masterClub={club}
                  club={selectedClub}
                  setSelectedClub={setSelectedClub}
                />
                <SaveButtons
                  cloned={selectedClub?.cloned}
                  setSelected={setSelected}
                  setSelectedClub={setSelectedClub}
                  setPreviewImages={setPreviewImages}
                  setMaster={setClub}
                  setCustomLinks={setCustomLinks}
                />
              </>
            )}
          </Container>
        </ClientForm>
      </Content>
    </>
  )
}
